import { useCallback } from "react";
import { Box } from "@mui/material";
import Button from "../button/Button";
import { getBtnTxt, openBtnTxt } from "../messages";
import CommonVideoImageComponent from "./CommonVideoImageComponent";
import TruncatedTextTooltip from "../TruncatedTextTooltip";
import {
  handleOpenAppDetailDialogAndPassDetails,
  handleOpenAppDialog,
} from "../constants";
import { loaderImg } from "../images";

const Carousel = ({ collectionData }) => {
  const handleOpenDetailDialog = useCallback((params) => {
    const { is_app_installed, id } = params?.data;
    if (is_app_installed) {
      handleOpenAppDialog(params);
    } else {
      handleOpenAppDetailDialogAndPassDetails({ id });
    }
  }, []);

  return (
    <Box className="carousel-wrapper" padding="0 15px">
      {collectionData?.map((data) => {
        const {
          logo_images,
          asset_url,
          asset_type,
          description,
          display_name,
          is_app_installed,
          thumbnail_url,
          id,
        } = data;

        let imgSrc = logo_images?.original || loaderImg;
        const isVideo = asset_type === "video";

        return (
          <Box
            key={id}
            className="carousel-box"
            onClick={() =>
              handleOpenDetailDialog({
                data,
              })
            }
            sx={{ cursor: "pointer" }}
          >
            <Box>
              <CommonVideoImageComponent
                isVideo={isVideo}
                thumbnail_url={thumbnail_url}
                asset_url={asset_url}
                isFrom="carousel"
              />
            </Box>

            <Box className="carousel-content">
              <Box display="flex" gap="10px" justifyContent="center">
                <img
                  className="logo"
                  src={imgSrc}
                  alt={display_name}
                  onError={(e) => {
                    e.target.src = loaderImg;
                  }}
                />
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={{ wordBreak: "break-all" }}
                  className="text-truncate"
                >
                  <TruncatedTextTooltip
                    textProps={{
                      className: "default-text ",
                      font: "semibold",
                    }}
                    textValue={display_name}
                    fontSize={16}
                  />

                  <TruncatedTextTooltip
                    textProps={{
                      className: "grey-text ",
                      font: "regular",
                    }}
                    textValue={description}
                    fontSize={12}
                  />
                </Box>
              </Box>
              <Button
                label={is_app_installed ? openBtnTxt : getBtnTxt}
                fullWidth={false}
                variant={is_app_installed ? "contained" : "outlined"}
                className="get-button"
                sx={{ color: is_app_installed ? "#ffffff" : "#003acc" }}
                tabIndex={0}
                textClass="font-12"
              />
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default Carousel;
